<template>
    <div class="mediaPlayerNavLinkWrapper" v-show="isDesktop">
        <button
            v-show="current"
            :disabled="isFirst"
            class="headlineNavLink headlineNavLink-prev"
            @click.prevent="onPrevClick"
            ref="prev"
            title="Previous">
            <back-logo-prev-icon/>
        </button>

        <button
            v-show="current"
            :disabled="isLast"
            class="headlineNavLink headlineNavLink-next"
            @click.prevent="onNextClick"
            ref="next"
            title="Next">
            <back-logo-next-icon/>
        </button>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {eventBus, } from "../utils/shared";

export default {
    computed: {
        ...mapGetters('ui', [
            'isDesktop',
        ]),
        ...mapGetters('player', [
            'current',
            'isFirst',
            'isLast',
            'prevLink',
            'nextLink',
        ]),
    },
    methods: {
        onPrevClick() {
            eventBus.$emit('player.prev')
        },
        onNextClick() {
            eventBus.$emit('player.next')
        }
    },
}
</script>

<style>
</style>
